import(/* webpackMode: "eager" */ "/app/src/app/[locale]/layout.tsx");
